/** Canonical cell IDs include the market, time window, and exact price bounds. */
export function groupPositions(positions) {
    const byCell = new Map();
    for (const position of positions) {
        const group = byCell.get(position.cellId);
        if (group)
            group.push(position);
        else
            byCell.set(position.cellId, [position]);
    }
    return Object.freeze([...byCell.values()].map((members) => {
        const first = members[0];
        let stake = 0n, potentialReturn = 0n, actualReturn = 0n;
        const statuses = new Set();
        for (const position of members) {
            stake += BigInt(position.stakeCents);
            potentialReturn += BigInt(position.grossReturnCents);
            if (position.status === 'won')
                actualReturn += BigInt(position.grossReturnCents);
            else if (position.status === 'refunded')
                actualReturn += BigInt(position.stakeCents);
            statuses.add(position.status);
        }
        const status = statuses.has('open') ? 'open'
            : statuses.size === 1 ? first.status : 'mixed';
        return Object.freeze({
            groupId: first.cellId,
            cellId: first.cellId,
            marketId: first.marketId,
            startMs: first.startMs,
            endMs: first.endMs,
            lowerPrice: first.lowerPrice,
            upperPrice: first.upperPrice,
            ruleVersion: first.ruleVersion,
            positions: Object.freeze(members),
            count: members.length,
            totalStakeCents: stake.toString(),
            totalPotentialReturnCents: potentialReturn.toString(),
            totalActualReturnCents: actualReturn.toString(),
            status,
        });
    }));
}
//# sourceMappingURL=position-groups.js.map